import { Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DialogService } from '../../services/dialog.service';
import { AutoCompleteItem } from '../../services/email-autocomplete.service';

interface WysiwygData {
  urlMode: boolean;
  href: string;
  position: DOMRect;
  fontFamily: string;
  defaultFontFamily: string;
  allowHtml: boolean;
  allowLink: boolean;
  disableHtml: boolean;
  showContext: boolean;
  allowFontChanges: boolean;
  allowHugeFontSize: boolean;
  allowAlignment: boolean;
  alignment: string; // 'left' | 'center' | 'right'
  fontSize: 'small' | 'medium' | 'large' | 'huge';
  fontWeight: string;
  textColor: string;
  allowTextColorReset: boolean;
  darkBackground: boolean;
  meta: {
    bold: boolean;
    italic: boolean;
    href: boolean;
  };
  onLink: (href?: string) => void;
  onAction: () => void;
  restoreSelection: () => void;
  onContextClicked: () => void;
  onChangeFont: (fontFamily: string) => void;
  onFontSizeChanged: (fontSize: 'small' | 'medium' | 'large') => void;
  onFontWeightChanged: (fontWeight: string) => void;
  onAlignmentChanged: (alignment: 'left' | 'center' | 'right') => void;
  onTextColorChanged: (color: string) => void;
  onClose: () => void;
  wysiwygHoverIdentifier: string;
}

interface MentionMenuData {
  position: DOMRect;
  mentionText: string;
  onMention: (user: AutoCompleteItem) => void;
  onClose: () => void;
  wysiwygHoverIdentifier: string;
}

@Injectable({
  providedIn: 'root',
})
export class WysiwygService {
  private router = inject(Router);
  private dialog = inject(DialogService);
  public onUpdates = new BehaviorSubject<WysiwygData>(undefined);
  public onMentionMenu = new BehaviorSubject<MentionMenuData>(undefined);
  public onUpdateMentionText = new BehaviorSubject<string>(undefined);

  constructor() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        window.getSelection().removeAllRanges();
        this.hideToolbar();
      }
    });
    this.dialog.dialog$.subscribe(dialog => {
      if (dialog) {
        this.hideToolbar();
      }
    });
  }

  public showToolbar(data: WysiwygData) {
    this.onUpdates.next(data);
  }

  public hideToolbar() {
    this.onUpdates.next(undefined);
  }

  public showMentionMenu(data: MentionMenuData) {
    this.onMentionMenu.next(data);
  }
  public updateMentionText(text: string) {
    this.onUpdateMentionText.next(text);
  }

  public hideMentionMenu() {
    this.onMentionMenu.next(undefined);
  }
}
